import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox, message, Modal, Alert, Space, Switch, Slider, Row, InputNumber, Col, Radio, Tag, Divider, Select } from 'antd';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { logout, updateGlobalSearch, selectPage, requestServerPost } from '../../actions';
import PopupManager from '../../managers/PopupManager';
import ReactPlayer from 'react-player';

const { Option } = Select;
const BASE_ONLINE_URL = "https://dg-directory-physical.cpn.co.th/directory/app_uat/"
const BASE_LOCAL_URL = "http://localhost/directoryv2/app_local/"

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const formTailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18, offset: 6 },
};

const CreateDirectoryURLMediaView = (props) => {
    const [form] = Form.useForm();
    const [fileData, setFileData] = useState(null)
    const [initialV, setInitialV] = useState({})
    const [serverTypeValue, setServerTypeValue] = useState("local")
    const [rotationValue, setRotationValue] = useState(0)
    const [scalingValue, setScalingValue] = useState(100)
    const [urlOutput, setURLOutput] = useState("")
    const [branchCodeValue, setBranchCodeValue] = useState("")
    const [directoryUnitName, setDirectoryUnitName] = useState("")
    const [errorMessage, setErrorMessage] = useState(null);
    const [accessBranches, setAccessBranches] = useState(["all"]);
    const { requestServerPost, usertoken, selectedBrandData, selectedBranchData, data = null, type = "web", branches = [], allBranchesOption = true, initialAccessBranches = ["all"] } = props;
    useEffect(() => {
        if ("data" in props && props.data) {
            console.log("data " + JSON.stringify(props.data))
            const datatype = props.data.FileType?.toLocaleLowerCase()

            if (datatype === "web" || datatype === "videourl") {

                const initial = {
                    medianame: props.data.FileName,
                    url: props.data.UploadFile
                }
                console.log("initial " + JSON.stringify(initial))

                form.setFieldsValue(initial)

                setFileData(props.data)
                setInitialV(initial)

            }

        }
    }, [])

    // When branches load (async), apply the folder-based default in create mode
    useEffect(() => {
        if (!data) {
            setAccessBranches(initialAccessBranches);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branches])

    useEffect(() => {

        const base = (serverTypeValue == "online") ? BASE_ONLINE_URL : BASE_LOCAL_URL;
        const branchCode = `?bc=${branchCodeValue.toLocaleUpperCase()}`
        const unitname = `&un=${directoryUnitName}`
        const rotation = `&r=${rotationValue}`
        const scaling = `&s=${scalingValue / 100}`

        const currentURL = `${base}${branchCode}${unitname}${rotation}${scaling}`

        setURLOutput(currentURL)
    }, [rotationValue, serverTypeValue, branchCodeValue, directoryUnitName, scalingValue])

    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    const onFinish = async values => {

        var params = {};

        params["brandid"] = selectedBrandData.BrandID;
        params["urlname"] = values.medianame;
        params["url"] = urlOutput;
        params["accessbranches"] = accessBranches.includes("all") ? "all" : accessBranches.join(",");
        // When All Branches is hidden (folder-restricted), expand "all" to the explicit branch IDs
        if (!allBranchesOption && params["accessbranches"] === "all" && branches.length > 0) {
            params["accessbranches"] = branches.map(b => String(b.BranchID)).join(",");
        }
        if (selectedBrandData?.ContentSharingMode == 2 && selectedBranchData) {
            params["accessbranches"] = String(selectedBranchData.BranchID);
        }

        let update_action = "update_weburl";
        let create_action = "create_weburl";

        if (type == "videourl") {

            update_action = "update_videourl";
            create_action = "create_videourl";
        }

        if (fileData) {
            params["fileid"] = fileData.FileID;
            requestServerPost(update_action, params, {  }, (response) => {

                PopupManager.closePopup();
            }, usertoken);
        }
        else {
            requestServerPost(create_action, params, {  }, (response) => {

                PopupManager.closePopup();
            }, usertoken);
        }
    };

    const onCreate = async () => {
        try {
            const values = await form.validateFields();
            // console.log('Success:', values);
        } catch (errorInfo) {
            // console.log('Failed:', errorInfo);
        }
    };



    const onServerTypeChange = (evt) => {
        const type = evt.target.value

        setServerTypeValue(type);
    };

    const onRotationChange = (value) => {
        if (isNaN(value)) {
            return;
        }
        setRotationValue(value);
    };

    const onScalingChange = (value) => {
        if (isNaN(value)) {
            return;
        }
        setScalingValue(value);
    };

    const onURLChanged = (evt) => {
        const url = evt.target.value
        const isURLValid = validURL(url)

        if (!isURLValid) {
            setErrorMessage('The inputted URL might be invalid');
        }
        else if (type == "videourl") {
            const canplay = ReactPlayer.canPlay(url);
            if (!canplay) {

                setErrorMessage('The inputted URL might not be playable');
            }
            else {
                setErrorMessage(null)
            }
        }
        else {
            setErrorMessage(null)
        }


    }

    const onBranchCodeChange = (evt) => {
        const code = evt.target.value


        setBranchCodeValue(code);

    }

    const onDirectoryUnitNameChange = (evt) => {
        const unitname = evt.target.value


        setDirectoryUnitName(unitname);

    }

    const handleAccessBranchesChange = (value) => {
        let newVal;
        if (value.includes("all") && !accessBranches.includes("all")) {
            newVal = ["all"];
        } else if (accessBranches.includes("all") && value.length > 1) {
            newVal = value.filter(v => v !== "all");
        } else if (value.length === 0) {
            newVal = ["all"];
        } else {
            newVal = value;
        }
        setAccessBranches(newVal);
    };

    let name_label = "Webiste Name";
    let name_message = 'Website name is required';
    let name_instruction = 'Input the name of your website';

    if (type == "videourl") {
        name_label = "Video URL Name";
        name_message = 'Video URL name is required';
        name_instruction = 'Input the name of your Video URL';
    }

    //Sample URL format
    //"http://localhost/directoryv2/app_local/?bc=NKW&un=NKW-D1-02r=-90&s=0.80"

    return (
        <div>
            <Alert
                style={{ margin: "16px 0" }}
                message="Warning"
                size="small"
                // description="Target directory must exist in order for this URL to work"
                description="Before using this URL, you need to make sure that the target directory already exists."
                type="warning"
                showIcon
                closable
            />

            <Form form={form} initialValues={initialV} onFinish={onFinish} name="dynamic_rule" style={{ width: "100%" }}>
                {(type == "videourl") &&
                    <Form.Item>
                        <Alert
                            message="Important : This media type only works with player version 0.1.12 and above"
                            type="info"
                        />
                    </Form.Item>}
                <Form.Item

                    {...formItemLayout}
                    name="medianame"
                    label={name_label}
                    rules={[
                        {
                            required: true,
                            message: name_message,
                        },
                    ]}
                >
                    <Input placeholder={name_instruction} />
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    name="type"
                    label="Server Type"
                    rules={[
                        {
                            required: false,
                            message: 'Server type is required',
                        },
                    ]}
                >

                    {/* <Switch checkedChildren="Online" unCheckedChildren="Local" defaultChecked={false} /> */}
                    <Radio.Group onChange={onServerTypeChange} defaultValue={serverTypeValue} value={serverTypeValue}>
                        <Radio value="local">Local</Radio>
                        <Radio value="online">Online</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    name="branchcode"
                    label="Branch Code"
                    rules={[
                        {
                            required: true,
                            message: 'Branch Code is required',
                        },
                    ]}
                >
                    <Input onChange={onBranchCodeChange} placeholder="CTW" />
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    name="directory"
                    label="Directory Unit Name"
                    rules={[
                        {
                            required: true,
                            message: 'Directory unit name is required',
                        },
                    ]}
                >
                    <Input onChange={onDirectoryUnitNameChange} placeholder="CTW-D1-01" />
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    name="rotation"
                    label="Start Rotation"
                    rules={[
                        {
                            required: false,
                            message: 'Rotation is required',
                        },
                    ]}
                >
                    <Row>
                        <Col span={12}>
                            <Slider
                                tooltip={{ formatter: (value) => `${value}°` }}
                                min={-360}
                                max={360}
                                onChange={onRotationChange}
                                value={typeof rotationValue === 'number' ? rotationValue : 0}
                                step={1}
                            />
                        </Col>
                        <Col span={12}>
                            <InputNumber
                                min={-360}
                                max={360}
                                style={{
                                    margin: '0 16px',
                                }}
                                step={1}
                                value={rotationValue}
                                onChange={onRotationChange}
                                addonAfter="degree"
                            />
                        </Col>
                    </Row>
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    name="scaling"
                    label="Start Scaling"
                    rules={[
                        {
                            required: false,
                            message: 'Scaling is required',
                        },
                    ]}
                >
                    <Row>
                        <Col span={12}>
                            <Slider
                                tooltip={{ formatter: (value) => `${value}%` }}
                                min={50}
                                max={500}
                                onChange={onScalingChange}
                                value={typeof scalingValue === 'number' ? scalingValue : 0}
                                step={1}
                            />
                        </Col>
                        <Col span={12}>
                            <InputNumber
                                min={50}
                                max={500}
                                style={{
                                    margin: '0 16px',
                                }}
                                step={1}
                                value={scalingValue}
                                onChange={onScalingChange}
                                addonAfter="%"
                            />
                        </Col>
                    </Row>
                </Form.Item>
                <Form.Item {...formTailLayout}>
                </Form.Item>
                {branches.length > 0 && (
                    <Form.Item {...formItemLayout} label="Accessible Branches">
                        <Select
                            allowClear
                            mode="multiple"
                            style={{ width: "100%", border: "1.5px solid #ccc", borderRadius: "5px", overflow: "hidden" }}
                            value={accessBranches}
                            onChange={handleAccessBranchesChange}
                            maxTagCount="responsive"
                        >
                            {allBranchesOption && <Option key="all" value="all">All Branches</Option>}
                            {branches.map(b => (
                                <Option key={b.BranchID} value={String(b.BranchID)}>{b.BranchName}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                )}
                <Form.Item >

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Space>
                            <Divider>URL Output:</Divider>
                            <Tag>{urlOutput}</Tag>
                            <Divider></Divider>
                        </Space>
                    </div>
                </Form.Item>
                <Form.Item {...formTailLayout}>
                    {
                        errorMessage ? <Alert
                            message="Warning"
                            showIcon
                            description={errorMessage}
                            type="warning"
                            action={
                                <Space direction="vertical">
                                    <Button onClick={() => { setErrorMessage(null) }} size="small" danger>
                                        Ignore Warning
                                    </Button>
                                </Space>
                            }
                        /> : <Button type="primary" htmlType="submit">
                            {fileData ? "Save" : "Create"}
                        </Button>
                    }
                </Form.Item>
            </Form >
        </div>
    );
};


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, globalSearch: state.globalSearch, selectedPage: state.selectedPage, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { logout, selectPage, updateGlobalSearch, requestServerPost })(CreateDirectoryURLMediaView);
